import React from 'react';
import { GetVersion } from 'components/layout/Header/Version/common/service/service';
import { useStyles as useStylesBase } from './common/styles/base';

const VersionComponent: React.FC = () => {
  const classesBase = useStylesBase();

  const { data: version } = GetVersion();

  return (
    <div className={classesBase.versionContainer}>
      {version ? (
        <div className={classesBase.versionTextContainer}>
          <p className={classesBase.versionText}>Версия - {version}</p>
        </div>
      ) : null}
    </div>
  );
};

export default VersionComponent;
